import React, { useEffect, useState } from 'react';
import { getYangBalance } from '../api/yang';
// TODO: 실제 로그인 유저 정보 훅/컨텍스트로 교체
// 아래는 예시용. 실제 프로젝트의 유저 정보 접근 방식에 맞게 수정 필요
import { useUser } from '../hooks/useUser'; 

export default function YangBalance({ showIcon = true }) {
  const { user } = useUser(); // user.id 등
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user?.id) {
      setLoading(true);
      getYangBalance(user.id)
        .then((b) => {
          setBalance(b);
          setError(null);
        })
        .catch(() => {
          setBalance(null);
          setError('잔고 오류');
        })
        .finally(() => setLoading(false));
    }
  }, [user?.id]);

  if (!user) return null;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', fontWeight: 600, fontSize: '1.1rem', marginLeft: 16 }}>
      {showIcon && <span role="img" aria-label="냥잔고" style={{ fontSize: '1.3rem', marginRight: 4 }}>🐾</span>}
      {loading ? '...' : error ? error : `${Number(balance).toLocaleString()}냥`}
    </span>
  );
}
